module.exports = __webpack_public_path__ + "media/images/browser-logos/internet-explorer-b86b4bdffc121d0eb5b30dcda9380bc2.png";